<template>
  <div class="rating-question">
    <div>
      <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
      <p v-if="node.prompt !== null" v-html="node.prompt"></p>
      <div v-html="node.question.instructions"></div>
      <div :class="{ 'slider-widget': true, 'slider-widget-vertical': node.question.vertical }">
        <h1 v-if="node.question.show_value">{{ value }}</h1>
        <div :class="{ 'slider-labels': true, 'slider-labels-vertical': node.question.vertical }">
          <div class="slider-label">{{ node.question.max_label }}</div>
          <div class="slider-label">{{ node.question.min_label }}</div>
        </div>
        <v-slider
          v-model="value"
          :class="{ 'rating-slider': true, 'vertical-slider': node.question.vertical }"
          :thumb-size="40"
          :vertical="node.question.vertical"
          :min="node.question.min_value"
          :max="node.question.max_value"
        >
        </v-slider>
      </div>
    </div>
    <div class="buttons">
      <v-btn
        class="submit-button"
        :disabled="!isValidSelection()"
        color="primary"
        @click="onAnswerQuestion"
      >
        {{ submitButton }}
      </v-btn>
      <v-btn v-if="node.skippable" class="submit-button" color="secondary" @click="onSkipQuestion">
        {{ skipButton }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatingQuestion',
  data() {
    return {
      value: this.node.question.initial_value,
    };
  },
  methods: {
    isValidSelection() {
      return this.value !== null;
    },
    onAnswerQuestion() {
      this.$emit('answer', { node: this.node, value: this.value });
      this.value = null;
    },
    onSkipQuestion() {
      this.$emit('skip');
      this.value = null;
    },
  },
  props: {
    node: Object,
    submitButton: String,
    skipButton: String,
  },
};
</script>

<style lang="scss">
@import '../styles/_variables.scss';

.rating-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .question-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .slider-widget {
    display: flex;
    width: 100%;
    flex-direction: column;

    h1 {
      display: block;
      width: 60px;
      align-self: center;
      text-align: center;
    }

    .slider-labels {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
    }

    .slider-labels-vertical {
      flex-direction: column;
      width: auto;
      height: 320px;
    }

    .rating-slider .v-slider__thumb {
      width: 30px;
      height: 30px;
      left: -15px;
    }

    .rating-slider .v-slider__thumb:before {
      left: -3px;
      top: -3px;
    }

    .vertical-slider {
      width: 40px;
      max-width: 40px;
    }

    .vertical-slider .v-slider {
      height: 300px;
      max-width: 40px;
    }
  }

  .slider-widget-vertical {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .rating-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
